import { useMemo } from 'react';
import useDashboardSelector from '../../../redux/selectorHooks/useDashboardSelector';
import { assertNotNil } from '../../../utils/types';
import {
  ConversationThreadEntityType,
  IConversationEntityInput,
} from '../../../utils/apollo/graphqlSchema';
import getDashboardAnalysesIds from '../../../pages/DashboardRoute/utils/getDashboardAnalysesIds';
import { ConversationThreads } from '../../Conversations';
import { useDashboardEntityPermission } from '../../../utils/hooks/permissionHooks/useDashboardEntityPermission';
import DashboardNotificationSettings from './DashboardNotificationSettings';

const DashboardComments = () => {
  const dashboard = useDashboardSelector('dashboard');
  assertNotNil(dashboard);
  const { baseId, rows } = dashboard;

  const { dashboardEntityPermissions } =
    useDashboardEntityPermission(dashboard);

  // Combine dashboard baseId with all analyses in rows
  const ids = useMemo<IConversationEntityInput[]>(() => {
    const dashboardAnalysesIds = getDashboardAnalysesIds(rows);

    return [
      {
        id: baseId,
        type: ConversationThreadEntityType.Dashboard,
      },
      ...dashboardAnalysesIds.map((analysisId) => ({
        id: analysisId,
        type: ConversationThreadEntityType.Analysis,
      })),
    ];
  }, [baseId, rows]);

  return (
    <ConversationThreads
      ids={ids}
      settingsComponent={
        <DashboardNotificationSettings
          dashboardBaseId={baseId}
          disabled={!dashboardEntityPermissions.editDashboard}
        />
      }
    />
  );
};

export default DashboardComments;
